import {jwtDecode} from 'jwt-decode';

// Helper to set user data in localStorage
export const setLocalStorageOnUserAuthentication = (jwtToken, userDocument) => {
  const acctType = userDocument?.auth?.acct_type ?? 'tracker';
  localStorage.setItem('jwt_token', jwtToken);
  localStorage.setItem('uid', userDocument.uid);
  localStorage.setItem('cid', userDocument?.company_details?.cid);
  localStorage.setItem('acct_type', acctType === 'tracker' ? 'iq' : acctType);
  localStorage.setItem('_appWhitelist', JSON.stringify(userDocument?.settings?._app_whitelist ?? []));
  localStorage.setItem('apps', JSON.stringify(userDocument?.settings?.apps ?? []));
};

// Helper to clear user data in localStorage
export const clearLocalStorageOnUserLogout = () => {
  localStorage.removeItem('jwt_token');
  localStorage.removeItem('uid');
  localStorage.removeItem('cid');
  localStorage.removeItem('acct_type');
  localStorage.removeItem('_appWhitelist');
  localStorage.removeItem('apps');
};

// Helper to decode JWT token (optional, only for expiry check or debugging)
export const isTokenExpired = (token) => {
    const decodedToken = jwtDecode(token);

  const currentTime = Date.now() / 1000;
  return decodedToken.exp < currentTime;
};

// Helper to make authenticated API calls
export const makeAuthenticatedRequest = async (url, method = 'POST', body = null) => {
  const jwtToken = localStorage.getItem('jwt_token');
  if (!jwtToken) throw new Error('No token available');

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${jwtToken}`
  };

  const response = await fetch(url, {
    method,
    headers,
    body: body ? JSON.stringify(body) : null,
  });

  const data = await response.json();
  if (response.status !== 200) {
    throw new Error(data.message || 'Failed request');
  }

  return data;
};
